var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic"},[_c('parts',{attrs:{"title":"新作商品"}}),_c('parts',{attrs:{"title":"期間限定"}}),_c('parts',{attrs:{"title":"人気商品"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }